import { Button, Typography } from "@mui/material";
import { colorPrincipale } from "../../util/env";

function ButtonSimple({ children, sx = {}, vide = false, ...props }) {
  return (
    <Button
      sx={{
        background: vide ? "#fff" : colorPrincipale, // Background color: white if vide, else main color
        border: `2px solid ${colorPrincipale}`,
        height: "8vh",
        ...sx,
      }}
      
      variant="contained"
      {...props}
    >
      <Typography
        variant="button"
        sx={{
          fontFamily: "Poppins",
          textTransform: "capitalize",
          color: vide ? colorPrincipale : "#fff",
          //  fontSize: "90%",
        }}
      >
        {children}
      </Typography>
    </Button>
  );
}

export default ButtonSimple;
